<template>
	<div class="customer">
		<ManagingSection>
			<ManagingBox title="사업자 사본 <br/> 업로드">
				<div v-if="source && isImage" class="customer__imgBox">
					<img :src="source" class="customer__img" />
				</div>
				<embed
					v-else-if="source && !isImage"
					:src="source"
					type="application/pdf"
					class="customer__pdf"
				/>
				<div class="customer__input-wrapper">
					<input
						type="file"
						ref="customerImg"
						@change="handleFileChange($event)"
					/>
					<div class="text-right">
						<p class="font-blue">선택된 파일이 있어야 가능합니다</p>
						<button
							:disabled="!file"
							class="btn"
							v-text="'텍스트 추출하기'"
							@click="extractText"
						/>
					</div>
				</div>
			</ManagingBox>
			<ManagingBox title="사업자 등록번호">
				<input
					v-model="registrationNumber"
					ref="texId"
					@blur="addHyphen"
					placeholder="숫자 10자리 입력 ( - 은 제외해주세요)"
					type="text"
				/>
			</ManagingBox>
			<ManagingBox title="법인 (단체명)">
				<input
					type="text"
					placeholder="법인명을 입력하세요."
					v-model="companyName"
				/>
			</ManagingBox>
			<ManagingBox title="대표자명">
				<input
					type="text"
					placeholder="대표자명을 입력하세요."
					v-model="ceoName"
				/>
			</ManagingBox>
			<ManagingBox title="사업장 소재지">
				<div class="customer__location">
					<input
						v-model="location"
						placeholder="사업장 소재지를 입력하세요"
						ref="location"
						type="text"
						class="customer__location-input"
					/>
					<button class="btn blue" @click="searchAddress">
						주소검색
					</button>
				</div>
			</ManagingBox>
			<ManagingBox title="업태">
				<input
					type="text"
					placeholder="업태를 입력하세요"
					v-model="industry"
				/>
			</ManagingBox>
			<ManagingBox title="종목">
				<input
					type="text"
					placeholder="종목을 입력하세요"
					v-model="item"
				/>
			</ManagingBox>
		</ManagingSection>
		<div
			class="customer__section"
			v-for="(item, index) in customerList"
			:key="index"
		>
			<ManagingSection class="customer__item">
				<ManagingBox title="브랜드명">
					<input
						v-model="item.brandTitle"
						type="text"
						placeholder="브랜드명을 입력하세요"
						ref="brandTitle"
					/>
				</ManagingBox>
				<ManagingBox title="퇴사여부">
					<RadioList
						v-model="item.managerIsQuit"
						:radio-list="leaveStatus"
						valueName="name"
						ref="managerIsQuit"
					/>
				</ManagingBox>
				<ManagingBox title="담당자명">
					<input
						v-model="item.managerName"
						type="text"
						placeholder="담당자명을 입력하세요"
						ref="managerName"
					/>
				</ManagingBox>
				<ManagingBox title="연락처">
					<input
						v-model="item.phone"
						type="text"
						placeholder="연락처를 입력하세요"
						ref="phone"
					/>
				</ManagingBox>
				<ManagingBox title="이메일 1">
					<input
						v-model="item.email"
						placeholder="이메일을 입력하세요"
						ref="email"
						type="text"
					/>
				</ManagingBox>
				<ManagingBox title="이메일 2">
					<input
						v-model="item.emailExtra"
						placeholder="이메일을 입력하세요"
						ref="emailExtra"
						type="text"
					/>
				</ManagingBox>
			</ManagingSection>
			<div class="customer__right-button-wrapper">
				<button
					v-if="customerList.length > 1"
					class="fa fas fa-minus customer__remove-btn"
					@click="removeTarget(index)"
				/>
				<button
					class="fa fas fa-files-o customer__duplicate-btn"
					@click="duplicateTarget(index)"
				/>
			</div>
		</div>
		<button @click="addTarget" class="fa fas fa-plus customer__add-btn" />
		<div class="btn-wrap-main">
			<button class="btn-main blue" @click="sumbit()">
				{{ mode === 'register' ? '등록' : '수정' }}
			</button>
			<button
				v-if="mode === 'modify'"
				@click="deleteItem(titleId)"
				class="btn-main red"
			>
				삭제
			</button>
			<button class="btn-main" @click="init()">초기화</button>
		</div>
	</div>
</template>
<script>
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import RadioList from '@/components/RadioList';
	import Util, { imageUpload, getImagePath } from '@/util';
	import { mapState } from 'vuex';
	import axios from 'axios';

	export default {
		data() {
			return {
				date: '',
				checkPurchase: [
					{ id: 1, name: '매입' },
					{ id: 2, name: '매출' },
				],
				purchase: 1,
				unitPrice: 0,
				leaveStatus: [
					{ id: 0, name: 'N' },
					{ id: 1, name: 'Y' },
				],
				isLeave: 0,
				customerList: [
					{
						brandTitle: '',
						managerIsQuit: 0,
						phone: '',
						managerName: '',
						email: '',
						emailExtra: '',
					},
				],
				registrationNumber: '',
				companyName: '',
				ceoName: '',
				location: '',
				industry: '',
				item: '',
				fileSaveName: '',
				fileDir: '',
				titleId: this.$route.params.titleId,
				source: '',
				file: null,
			};
		},
		props: {
			mode: {
				type: String,
				default: 'register',
			},
		},
		components: {
			ManagingSection,
			ManagingBox,
			RadioList,
		},
		computed: {
			...mapState({
				imgPath: state => state.env.IMAGE_STORAGE_PATH,
			}),
			isImage() {
				const imageExtension = [
					'jpg',
					'jpeg',
					'png',
					'gif',
					'bmp',
					'svg',
					'webp',
				];
				const extension = this.source.split('.').pop().toLowerCase();
				return imageExtension.includes(extension);
			},
		},
		created() {
			this.getData();
		},
		methods: {
			init() {
				(this.source = ''),
					(this.registrationNumber = ''),
					(this.ceoName = ''),
					(this.companyName = ''),
					(this.location = ''),
					(this.item = ''),
					(this.industry = ''),
					(this.customerList = [
						{
							id: '',
							brandTitle: '',
							managerIsQuit: 0,
							phone: '',
							managerName: '',
							email: '',
							emailExtra: '',
						},
					]);
			},
			async getData() {
				if (this.mode === 'modify' && this.titleId) {
					try {
						const { data } = await this.$axiosAdmin2.get(
							`/api/customerManageV2/${this.titleId}`
						);
						this.registrationNumber = data.registrationNumber;
						this.companyName = data.companyName;
						this.ceoName = data.ceoName;
						this.location = data.location;
						this.industry = data.industry;
						this.item = data.item;
						this.customerList =
							data.customerManageV2MetaInfoResDTOList;
						this.source = data.registrationCertificateFullPath;
					} catch (err) {
						console.error(err);
					}
				}
			},
			addTarget() {
				this.customerList.push({
					id: '',
					brandTitle: '',
					managerIsQuit: 0,
					phone: '',
					managerName: '',
					email: '',
					emailExtra: '',
				});
			},
			duplicateTarget(idx) {
				const {
					id,
					brandTitle,
					managerIsQuit,
					phone,
					managerName,
					email,
					emailExtra,
				} = this.customerList[idx];
				this.customerList = this.customerList.toSpliced(idx + 1, 0, {
					id,
					brandTitle,
					managerIsQuit,
					phone,
					managerName,
					email,
					emailExtra,
				});
			},
			removeTarget(index) {
				this.customerList.splice(index, 1);
			},
			addHyphen() {
				const pattern = /^\d{3}-\d{2}-\d{5}$/;
				const numericInput = this.registrationNumber.replace(
					/(\d{3})(\d{2})(\d{5})/,
					'$1-$2-$3'
				);
				this.registrationNumber = numericInput;
				if (
					this.registrationNumber &&
					!pattern.test(this.registrationNumber)
				) {
					alert(
						'올바른 형식이 아닙니다. 숫자만 10자리 형태로 입력해주세요.(-은 제외)'
					);
					this.registrationNumber = '';
					this.$refs.texId.focus();
					return;
				}
			},
			addImg(urlList, files) {
				const list = urlList.map((url, idx) => {
					const srcObj = {
						src: url,
						fileObject: files[idx],
						extension: files[idx].type.split('/').pop(),
					};
					return srcObj;
				});
				this.uploadImage(list[0]);
			},
			async uploadImage(imageObj) {
				const { extension, fileObject } = imageObj;

				try {
					const res = await imageUpload(
						extension,
						'customer-img',
						fileObject
					);
					const filePath = `/${res.config.data.get('key')}`;
					const fileSaveName = filePath.split('/').pop();
					const imgPath = filePath.replace(/\/[^/]+\/?$/, '');

					this.source = getImagePath(imgPath, fileSaveName);
					this.fileDir = imgPath;
					this.fileSaveName = fileSaveName;
				} catch (err) {
					console.error(err);
				}
			},
			readFile(file) {
				return new Promise(resolve => {
					const reader = new FileReader();
					reader.onload = e => {
						resolve(e);
					};
					reader.readAsDataURL(file);
				});
			},
			async handleFileChange(event) {
				const files = [...event.target.files];
				this.file = files[0];
				const readFileList = await Promise.all(
					files.map(file => this.readFile(file))
				);
				const urlList = readFileList.map(({ target }) => target.result);
				this.addImg(urlList, files);
			},
			async deleteItem(id) {
				try {
					if (!confirm('정말 삭제하시겠습니까?')) return;
					await this.$axiosAdmin2.delete(
						`/api/customerManageV2/${id}`
					);
					this.$router.push('/intranet/customer-manage');
				} catch (err) {
					console.error(err);
				}
			},
			searchAddress() {
				new window.daum.Postcode({
					oncomplete: data => {
						let fullRoadAddr = data.roadAddress;
						let extraRoadAddr = '';
						if (
							data.bname !== '' &&
							/[동|로|가]$/g.test(data.bname)
						) {
							extraRoadAddr += data.bname;
						}
						if (
							data.buildingName !== '' &&
							data.apartment === 'Y'
						) {
							extraRoadAddr +=
								extraRoadAddr !== ''
									? ', ' + data.buildingName
									: data.buildingName;
						}
						if (extraRoadAddr !== '') {
							extraRoadAddr = ' (' + extraRoadAddr + ')';
						}
						if (fullRoadAddr !== '') {
							fullRoadAddr += extraRoadAddr;
						}
						this.location = fullRoadAddr;
					},
				}).open();
				this.$refs.location.blur();
			},
			validation() {
				if (!this.registrationNumber) {
					alert('사업자 등록번호를 입력해주세요');
					return false;
				}
				if (!this.companyName) {
					alert('법인명을 입력해 주세요');
					return false;
				}
				if (!this.ceoName) {
					alert('대표자명을 입력해 주세요');
					return false;
				}
				if (!this.customerList[0].brandTitle) {
					alert('브랜드명을 입력해 주세요');
					return false;
				}
				if (!this.customerList[0].managerName) {
					alert('담당자명을 입력해 주세요');
					return false;
				}
				if (!this.customerList[0].email) {
					alert('이메일1을 입력해주세요');
					return false;
				}
				return true;
			},
			getImagePath() {
				const file = this.source.split('/').reverse();
				this.fileSaveName = file[0];
				this.fileDir = this.source
					.replace(`/${this.fileSaveName}`, '')
					.replace(this.imgPath, '');
			},
			async sumbit() {
				if (!this.validation()) return false;
				try {
					const params = {
						registrationNumber: this.registrationNumber,
						companyName: this.companyName,
						ceoName: this.ceoName,
						location: this.location,
						industry: this.industry,
						item: this.item,
						fileDir: this.fileDir,
						fileSaveName: this.fileSaveName,
						customerManageV2MetaInfoReqDTOList: [
							...this.customerList,
						],
					};

					if (this.mode === 'register') {
						await this.$axiosAdmin2.post(
							'/api/customerManageV2',
							params
						);
					} else {
						if (this.source) {
							this.getImagePath();
							params.fileDir = this.fileDir;
							params.fileSaveName = this.fileSaveName;
						}
						await this.$axiosAdmin2.put(
							`/api/customerManageV2/${this.titleId}`,
							params
						);
					}
					alert(
						`${this.mode === 'register' ? '등록' : '수정'} 되었습니다.`
					);

					this.$router.push('/intranet/customer-manage');
				} catch (err) {
					console.error(err);
					const msg = err.response.data.message;
					if (!msg)
						msg = `${this.mode === 'register' ? '등록' : '수정'}에 실패하였습니다.`;
					alert(msg);
				}
			},
			async extractText() {
				try {
					const formData = new FormData();
					formData.append('file', this.file);
					const { data } = await this.$axiosAdmin2.post(
						'/api/gpt/analyze-business-license',
						formData
					);
					this.registrationNumber = data.registrationNumber;
					this.ceoName = data.ceoName;
					this.companyName = data.companyName;
					this.industry = data.business_type.industry;
					this.item = data.business_type.item;
					alert('텍스트 추출하기에 성공했습니다.');
				} catch (err) {
					console.error(err);
					alert('텍스트 추출하기에 실패했습니다.');
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.customer {
		&__imgBox {
			width: 300px;
			max-height: 500px;
			margin: 20px 0;
			overflow-y: auto;
		}
		&__img {
			width: 100%;
		}
		&__pdf {
			width: 300px;
			height: 500px;
			margin: 20px 0;
		}

		&__input-wrapper {
			display: flex;
			width: 100%;
			align-items: center;
			justify-content: space-between;
		}

		&__section {
			display: flex;
			justify-content: center;
			align-items: center;
		}
		&__item {
			flex-grow: 1;
		}

		&__right-button-wrapper {
			margin-left: 10px;
			flex-shrink: 0;
		}

		&__remove-btn,
		&__add-btn,
		&__duplicate-btn {
			display: block;
			width: 36px;
			height: 36px;
			background: $btn-blue;
			border-radius: 50%;
			line-height: 36px;
			color: #fff;
			font-size: 20px;
		}

		&__remove-btn {
			background: $btn-red;
		}

		&__duplicate-btn {
			margin-top: 10px;
		}

		&__add-btn {
			margin-top: 40px;
			margin: 40px auto 0 auto;
		}

		&__location {
			display: flex;
			flex-direction: row;
		}

		&__location-input {
			width: 500px !important;
			margin-right: 10px;
			margin-bottom: 10px;
		}
	}
</style>
